import React from 'react';
import { Section } from './Section';
import { Music, Home, Disc3, Headphones } from 'lucide-react';
const features = [{
  icon: Music,
  title: 'Covers en vivo (sonido real)'
}, {
  icon: Home,
  title: 'Formato íntimo (cerca, como en un living)'
}, {
  icon: Disc3,
  title: 'Clásicos del rock argentino de los 80s y 90s'
}, {
  icon: Headphones,
  title: 'Videos ideales para escuchar con auriculares o en parlantes'
}];
export function Features() {
  return <Section data-id="element-20">
      <div className="text-center mb-16" data-id="element-21">
        <h2 className="text-3xl md:text-5xl font-serif mb-4" data-id="element-22">
          Qué vas a encontrar en PampaNation
        </h2>
        <p className="text-xl text-amber-400/90 font-serif italic" data-id="element-23">
          Un formato simple, pero poderoso:
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-24">
        {features.map((feature, idx) => <div key={idx} className="bg-surface border border-white/5 p-8 rounded-2xl flex items-start gap-6 hover:bg-surfaceHover transition-colors duration-300" data-id="element-25">
            <div className="bg-amber-500/10 p-4 rounded-full shrink-0" data-id="element-26">
              <feature.icon className="w-8 h-8 text-amber-400" data-id="element-27" />
            </div>
            <div className="pt-1" data-id="element-28">
              <h3 className="text-xl font-medium text-gray-100 leading-snug" data-id="element-29">
                {feature.title}
              </h3>
            </div>
          </div>)}
      </div>
    </Section>;
}